module.exports = __webpack_public_path__ + "static/media/Credibility-Illustration.e6956e30.svg";